import mutations from './mutations'
import getters from './getters'
import actions from './actions'
export default {
  namespaced: true,
  state: {
    channelToken: [],
    channel: null,
    checkManagePage: false
  },
  mutations,
  getters,
  actions
}
